<template>
    <div>
        <div class="block-content block-content-full overflow-hidden mb-2 rounded-12">
            <div class="block w-80">
                <div class="block-header pb-4">
                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">Informations générales</h3>
                </div>
                <div class="row justify-content-center">
                    <div class="col-sm-10 col-md-11">
                        <div class="row justify-content-center">
                            <form @submit.prevent="handleSubmit">
                                <div class="row">
                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="name" class="form-label">Nom<span class="text-purple">*</span></label>
                                            <input
                                                v-model="food.name"
                                                id="name"
                                                class="form-control"
                                                placeholder="Nom"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="subtitle" class="form-label">Sous-titre </label>
                                            <input
                                                v-model="food.subtitle"
                                                id="subtitle"
                                                class="form-control"
                                                placeholder="Sous-titre"
                                            />
                                        </div>
                                    </div>

                                    <!-- <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label for="slug" class="form-label">Slug </label>
                                            <input
                                                v-model="food.slug"
                                                id="slug"
                                                class="form-control"
                                                placeholder="Slug"
                                            />
                                        </div>
                                    </div> -->

                                    <!-- sur place start -->
                                    <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mt-4">
                                        Sur place (obligatoire)
                                    </h3>

                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label" for="vat_rate"
                                            >Taux de TVA en (%)<span class="text-purple">*</span></label
                                        >
                                        <div class="input-group rounded-12 overflow-hidden">
                                            <select
                                                v-model="food.vat_rate"
                                                class="form-select form-control"
                                                @change="calculatePriceHT()"
                                                required
                                            >
                                                <option v-for="vat in country_vat_rates" :key="vat.id" :value="vat.pourcentage">
                                                    {{ vat.pourcentage }} - {{ vat.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <label class="form-label" for="price"
                                            >Prix de vente TTC (en {{ $symbolCurrency }})
                                            <span class="text-purple">*</span></label
                                        >
                                        <div class="input-group rounded-12 overflow-hidden">
                                            <input
                                                type="text"
                                                step="0.01"
                                                class="form-control"
                                                v-model="food.price"
                                                :placeholder="$placeholderText('Prix de vente (en ', $symbolCurrency, ')')"
                                                required
                                                @input="calculatePrice()"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12 d-none">
                                        <label class="form-label" for="price_ht"
                                            >Prix HT en ({{ $symbolCurrency }})<span class="text-purple">*</span></label
                                        >
                                        <div class="input-group rounded-12 overflow-hidden">
                                            <input
                                                type="text"
                                                step="any"
                                                class="form-control"
                                                v-model="food.price_ht"
                                                :placeholder="$placeholderText('Prix HT (en ', $symbolCurrency, ')')"
                                                required
                                                @input="calculatePriceHT()"
                                            />
                                        </div>
                                    </div>
                                    <!-- sur place end -->

                                    <div class="col-12 mt-2">
                                        <h6 class="fs-6 fw-medium ppv2-text-black pt-1 mt-2">Emporter (Oui/Non)</h6>
                                        <div class="form-check form-switch" style="padding-left: 0">
                                            <input
                                                type="checkbox"
                                                v-model="food.is_active_takeaway"
                                                class="form-control form-check-input"
                                                @change="handleIsActiveTakeawayChange($event)"
                                            />
                                        </div>
                                    </div>

                                    <template v-if="food.is_active_takeaway">
                                        <!-- takeaway start -->
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-4">
                                            Emporter (facultatif)
                                        </h3>

                                        <div class="col-lg-6 col-xs-12">
                                            <label class="form-label" for="vat_rate_takeaway">Taux de TVA en (%)</label>
                                            <div class="input-group rounded-12 overflow-hidden">
                                                <select
                                                    v-model="food.vat_rate_takeaway"
                                                    class="form-select form-control"
                                                    @change="calculatePriceHTTakeaway()"
                                                    required
                                                >
                                                    <option
                                                        v-for="vat in country_vat_rates"
                                                        :key="vat.id"
                                                        :value="vat.pourcentage"
                                                    >
                                                        {{ vat.pourcentage }} - {{ vat.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-xs-12">
                                            <label class="form-label" for="price_takeaway"
                                                >Prix de vente en ({{ $symbolCurrency }})</label
                                            >
                                            <div class="input-group rounded-12 overflow-hidden">
                                                <input
                                                    type="text"
                                                    step="any"
                                                    class="form-control"
                                                    v-model="food.price_takeaway"
                                                    :placeholder="$placeholderText('Prix de vente (en ', $symbolCurrency, ')')"
                                                    @input="calculatePriceTakeaway()"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-lg-4 col-xs-12 d-none">
                                            <label class="form-label" for="price_ht_takeaway"
                                                >Prix HT en ({{ $symbolCurrency }})</label
                                            >
                                            <div class="input-group rounded-12 overflow-hidden">
                                                <input
                                                    type="text"
                                                    step="any"
                                                    class="form-control"
                                                    v-model="food.price_ht_takeaway"
                                                    :placeholder="$placeholderText('Prix HT (en ', $symbolCurrency, ')')"
                                                    @input="calculatePriceHTTakeaway()"
                                                />
                                            </div>
                                        </div>
                                        <!-- takeaway end -->
                                    </template>

                                    <div class="col-12 mt-2">
                                        <h6 class="fs-6 fw-medium ppv2-text-black pt-1 mt-2">Livraison (Oui/Non)</h6>
                                        <div class="form-check form-switch" style="padding-left: 0">
                                            <input
                                                type="checkbox"
                                                v-model="food.is_active_delivery"
                                                class="form-control form-check-input"
                                                @change="handleIsActiveDeliveryChange($event)"
                                            />
                                        </div>
                                    </div>

                                    <template v-if="food.is_active_delivery">
                                        <!-- delivery start -->
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mb-4">
                                            Livraison (facultatif)
                                        </h3>

                                        <div class="col-lg-6 col-xs-12">
                                            <label class="form-label" for="vat_rate_delivery">Taux de TVA en (%)</label>
                                            <div class="input-group rounded-12 overflow-hidden">
                                                <select
                                                    v-model="food.vat_rate_delivery"
                                                    class="form-select form-control"
                                                    @change="calculatePriceHTDelivery()"
                                                    required
                                                >
                                                    <option
                                                        v-for="vat in country_vat_rates"
                                                        :key="vat.id"
                                                        :value="vat.pourcentage"
                                                    >
                                                        {{ vat.pourcentage }} - {{ vat.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-xs-12">
                                            <label class="form-label" for="price_delivery"
                                                >Prix de vente en ({{ $symbolCurrency }})</label
                                            >
                                            <div class="input-group rounded-12 overflow-hidden">
                                                <input
                                                    type="text"
                                                    step="any"
                                                    class="form-control"
                                                    v-model="food.price_delivery"
                                                    :placeholder="$placeholderText('Prix de vente (en ', $symbolCurrency, ')')"
                                                    @input="calculatePriceDelivery()"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-lg-4 col-xs-12 d-none">
                                            <label class="form-label" for="price_ht_delivery"
                                                >Prix HT en ({{ $symbolCurrency }})</label
                                            >
                                            <div class="input-group rounded-12 overflow-hidden">
                                                <input
                                                    type="text"
                                                    step="any"
                                                    class="form-control"
                                                    v-model="food.price_ht_delivery"
                                                    :placeholder="$placeholderText('Prix HT (en ', $symbolCurrency, ')')"
                                                    @input="calculatePriceHTDelivery()"
                                                />
                                            </div>
                                        </div>
                                        <!-- delivery end -->
                                    </template>

                                    <div class="col-lg-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="parentCategory" class="form-label"
                                                >Catégorie<span class="text-purple">*</span></label
                                            >
                                            <v-select
                                                class="v-select"
                                                id="parentCategory"
                                                v-model="food.category_id"
                                                :options="ListCategories"
                                                label="name"
                                                :placeholder="'-- Sélectionnez une catégorie --'"
                                                required
                                            >
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        Aucun résultat trouvé pour <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <!-- <div class="form-group">
                                            <label for="kitchen" class="form-label">Cuisine </label>
                                            <v-select
                                                class="v-select"
                                                id="kitchen"
                                                v-model="food.kitchen_id"
                                                :options="ListKitchens"
                                                label="name"
                                                :placeholder="'-- Sélectionnez une cuisine --'"
                                            />
                                        </div> -->
                                    </div>

                                    <div class="col-lg-8 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="supplement" class="form-label">Suppléments </label>
                                            <v-select
                                                class="v-select"
                                                id="supplement"
                                                v-model="food.supplements"
                                                :options="filteredSupplements"
                                                label="name"
                                                multiple
                                                hide-selected
                                                :get-option-label="(option) => option.name"
                                                :placeholder="'Suppléments'"
                                            >
                                                <template #option="{ name, price }">
                                                    {{ name }} - {{ formatPriceWithSymbol(price) }}
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        Aucun résultat trouvé pour <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="supplement_free" class="form-label">Nombre d'élément(s) inclus</label>
                                            <input
                                                type="text"
                                                step="any"
                                                min="0"
                                                class="form-control"
                                                placeholder="Supplément(s) gratuit(s)"
                                                v-model="food.supplementFreeItem"
                                                @keyup="handleSupplementFreeItemChange($event.target.value)"
                                                id="supplement_free"
                                            />
                                        </div>
                                    </div>

                                    <div class="mt-3">
                                        <span class="row" v-for="(supplement, indexItem) in food.supplements" :key="indexItem">
                                            <div class="col-4">
                                                <div class="input-group rounded-12 overflow-hidden">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="supplement.name"
                                                        disabled="true"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-3">
                                                <!-- <label class="form-label" for="price">Prix</label> -->
                                                <div class="input-group rounded-12 overflow-hidden p-1">
                                                    <input
                                                        type="text"
                                                        step="any"
                                                        class="form-control"
                                                        v-model="supplement.price"
                                                        placeholder="Prix "
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-4">
                                                <div class="form-check inline-block rounded-24 mt-4">
                                                    <label :id="'foodSupplementIsFree' + indexItem" class="form-label">
                                                        <input
                                                            type="checkbox"
                                                            :value="supplement.id"
                                                            :checked="supplement.isFree"
                                                            :id="'foodSupplementIsFree' + indexItem"
                                                            @change="handleCheckboxSupplementsChange($event, 'isFree')"
                                                        />
                                                        Inclus
                                                    </label>
                                                </div>
                                                <div class="form-check inline-block rounded-24 mt-4">
                                                    <label :id="'foodSupplementIsRequired' + indexItem" class="form-label">
                                                        <input
                                                            type="checkbox"
                                                            :value="supplement.id"
                                                            :checked="supplement.isRequired"
                                                            :id="'foodSupplementIsRequired' + indexItem"
                                                            @change="handleCheckboxSupplementsChange($event, 'isRequired')"
                                                        />
                                                        Obligatoire
                                                    </label>
                                                </div>
                                                <div class="form-check inline-block rounded-24 mt-4">
                                                    <label :id="'foodSupplementIndexItem1Qty' + indexItem" class="form-label">
                                                        <input
                                                            type="checkbox"
                                                            :value="supplement.id"
                                                            :checked="supplement.forceOneQty"
                                                            :id="'foodSupplementIndexItem1Qty' + indexItem"
                                                            @change="handleCheckboxSupplementsChange($event, 'forceOneQty')"
                                                        />
                                                        Maximum 1 option
                                                    </label>
                                                </div>
                                            </div>
                                        </span>
                                    </div>

                                    <div class="col-lg-8 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="supplement" class="form-label">Boissons </label>
                                            <v-select
                                                class="v-select"
                                                id="supplement"
                                                v-model="food.boissons"
                                                :options="filteredBoissons"
                                                label="name"
                                                multiple
                                                hide-selected
                                                :get-option-label="(option) => option.name"
                                                :placeholder="'Boissons'"
                                            >
                                                <template #option="{ name, price }">
                                                    {{ name }} - {{ formatPriceWithSymbol(price) }}
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        Aucun résultat trouvé pour <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="boissons_free" class="form-label">Nombre d'élément(s) inclus</label>
                                            <input
                                                type="text"
                                                step="any"
                                                min="0"
                                                class="form-control"
                                                placeholder="Supplément(s) gratuit(s)"
                                                v-model="food.boissonFreeItem"
                                                @keyup="handleBoissonFreeItemChange($event.target.value)"
                                                id="boissons_free"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12" v-if="isFoodCategory"></div>

                                    <div class="mt-3">
                                        <span class="row" v-for="(boisson, indexItem) in food.boissons" :key="indexItem">
                                            <div class="col-4">
                                                <div class="input-group rounded-12 overflow-hidden">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="boisson.name"
                                                        disabled="true"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-3">
                                                <!-- <label class="form-label" for="price">Prix</label> -->
                                                <div class="input-group rounded-12 overflow-hidden p-1">
                                                    <input
                                                        type="text"
                                                        step="any"
                                                        class="form-control"
                                                        v-model="boisson.price"
                                                        placeholder="Prix "
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-3">
                                                <div class="input-group rounded-12 mt-4">
                                                    <label :id="'boissonSupplement' + indexItem" class="form-label">
                                                        <input
                                                            type="checkbox"
                                                            :value="boisson.id"
                                                            :checked="boisson.isFree"
                                                            :id="'boissonSupplement' + indexItem"
                                                            @change="handleCheckboxDrinksChange($event)"
                                                        />
                                                        gratuit
                                                    </label>
                                                </div>
                                            </div>
                                        </span>
                                    </div>

                                    <div class="col-lg-8 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="sauces" class="form-label">Sauce </label>
                                            <v-select
                                                class="v-select"
                                                id="sauces"
                                                v-model="food.sauces"
                                                :options="filteredSauces"
                                                label="name"
                                                multiple
                                                hide-selected
                                                :placeholder="'Sauce'"
                                            >
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        Aucun résultat trouvé pour <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="sauces_free" class="form-label">Nombre d'élément(s) inclus</label>
                                            <input
                                                type="text"
                                                step="any"
                                                class="form-control"
                                                placeholder="Sauce(s) gratuite(s)"
                                                v-model="food.saucesFreeItem"
                                                @keyup="handleSaucesFreeItemChange($event.target.value)"
                                                id="sauces_free"
                                            />
                                        </div>
                                    </div>

                                    <div class="mt-3">
                                        <span class="row" v-for="(sauce, indexItem) in food.sauces" :key="indexItem">
                                            <div class="col-4">
                                                <div class="input-group rounded-12 overflow-hidden">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="sauce.name"
                                                        disabled="true"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-3">
                                                <!-- <label class="form-label" for="price">Prix</label> -->
                                                <div class="input-group rounded-12 overflow-hidden p-1">
                                                    <input
                                                        type="text"
                                                        step="any"
                                                        class="form-control"
                                                        v-model="sauce.price"
                                                        placeholder="Prix "
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-3">
                                                <div class="input-group rounded-12 mt-4">
                                                    <label :id="'sauceSupplement' + indexItem" class="form-label">
                                                        <input
                                                            type="checkbox"
                                                            :value="sauce.id"
                                                            :checked="sauce.isFree"
                                                            :id="'sauceSupplement' + indexItem"
                                                            @change="handleCheckboxSaucesChange($event)"
                                                        />
                                                        gratuit
                                                    </label>
                                                </div>
                                            </div>
                                        </span>
                                    </div>

                                    <div class="col-lg-8 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="complements" class="form-label">Compléments </label>
                                            <v-select
                                                class="v-select"
                                                id="complements"
                                                v-model="food.complements"
                                                :options="filteredComplements"
                                                label="name"
                                                multiple
                                                hide-selected
                                                :placeholder="'Compléments'"
                                            >
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        Aucun résultat trouvé pour <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12" v-if="isFoodCategory && !optionsArray.includes(paramsSlug)">
                                        <div class="form-group">
                                            <label for="complements_free" class="form-label">Nombre d'élément(s) inclus</label>
                                            <input
                                                type="text"
                                                step="any"
                                                min="0"
                                                class="form-control"
                                                placeholder="Complément(s) gratuit(s)"
                                                v-model="food.complementFreeItem"
                                                @keyup="handleComplementFreeItemChange($event.target.value)"
                                                id="complements_free"
                                            />
                                        </div>
                                    </div>

                                    <div class="mt-3">
                                        <span class="row" v-for="(complement, indexItem) in food.complements" :key="indexItem">
                                            <div class="col-4">
                                                <div class="input-group rounded-12 overflow-hidden">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="complement.name"
                                                        disabled="true"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-3">
                                                <!-- <label class="form-label" for="price">Prix</label> -->
                                                <div class="input-group rounded-12 overflow-hidden p-1">
                                                    <input
                                                        type="text"
                                                        step="any"
                                                        class="form-control"
                                                        v-model="complement.price"
                                                        placeholder="Prix "
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-3">
                                                <div class="input-group rounded-12 mt-4">
                                                    <label :id="'complementSupplement' + indexItem" class="form-label">
                                                        <input
                                                            type="checkbox"
                                                            :value="complement.id"
                                                            :checked="complement.isFree"
                                                            :id="'complementSupplement' + indexItem"
                                                            @change="handleCheckboxComplementsChange($event)"
                                                        />
                                                        gratuit
                                                    </label>
                                                </div>
                                            </div>
                                        </span>
                                    </div>

                                    <div class="col-lg-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="shortDescription" class="form-label">Courte description</label>
                                            <textarea
                                                v-model="food.short_description"
                                                id="shortDescription"
                                                class="form-control"
                                                placeholder="Courte description"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="description" class="form-label">Description</label>
                                            <textarea
                                                v-model="food.description"
                                                id="description"
                                                class="form-control"
                                                placeholder="Description"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <!-- <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="seoTitle" class="form-label">SEO Title:</label>
                                            <input
                                                v-model="food.seo_title"
                                                id="seoTitle"
                                                class="form-control"
                                                placeholder="SEO Title"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="seoKeywords" class="form-label">SEO Keywords:</label>
                                            <input
                                                v-model="food.seo_keywords"
                                                id="seoKeywords"
                                                class="form-control"
                                                placeholder="SEO Keywords"
                                            />
                                        </div>
                                    </div> -->
                                </div>

                                <!-- <div class="col-lg-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="seoDescription" class="form-label">SEO Description:</label>
                                        <textarea
                                            v-model="food.seo_description"
                                            id="seoDescription"
                                            class="form-control"
                                            placeholder="SEO Description"
                                        ></textarea>
                                    </div>
                                </div> -->

                                <div class="col-lg-6 col-xs-12">
                                    <h6 class="fs-6 fw-medium ppv2-text-black pt-1 mt-2">Active</h6>
                                    <div class="form-check form-switch" style="padding-left: 0">
                                        <input
                                            type="checkbox"
                                            id="active"
                                            v-model="food.active"
                                            class="form-control form-check-input"
                                        />
                                    </div>
                                </div>

                                <div class="row mt-4" v-if="isFoodCategory">
                                    <div class="block-header pb-4">
                                        <h3 class="text-center block-title fs-5 fw-semibold text-light-blue mt-4 mb-2">
                                            Option(s)
                                        </h3>
                                    </div>

                                    <div class="row" v-for="(foodAttributesItem, indexItem) in foodAttributes" :key="indexItem">
                                        <div class="col-lg-6 col-xs-12">
                                            <div class="form-group">
                                                <label :id="'foodAttributesItem' + indexItem" class="form-label">Options </label>
                                                <v-select
                                                    class="v-select"
                                                    :id="'foodAttributesItem' + indexItem"
                                                    v-model="foodAttributesItem.name"
                                                    :options="ListAttributes"
                                                    label="name"
                                                    :disabled="true"
                                                    :placeholder="'-- Sélectionnez une option --'"
                                                >
                                                    <template v-slot:no-options="{ search, searching }">
                                                        <template v-if="searching">
                                                            Aucun résultat trouvé pour <em>{{ search }}</em
                                                            >.
                                                        </template>
                                                        <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                    </template>
                                                </v-select>

                                                <span
                                                    class="btn btn-sm btn-outline-dark mt-3 rounded-12 fw-semibold fs-xs width-btn-option-food"
                                                    @click="deleteOption(indexItem)"
                                                >
                                                    Supprimer</span
                                                >
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-xs-12">
                                            <table>
                                                <tr
                                                    class="form-group"
                                                    v-for="(value, index) in foodAttributesItem?.values"
                                                    :key="index"
                                                >
                                                    <td width="250">
                                                        <label
                                                            :for="'foodAttributesItemCheckbox' + indexItem + index"
                                                            class="form-label"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                :value="value.id"
                                                                :checked="value.checked"
                                                                :id="'foodAttributesItemCheckbox' + indexItem + index"
                                                                @change="handleItemValueCheckboxChange($event, indexItem)"
                                                            />
                                                            {{ value.key }}
                                                        </label>
                                                    </td>
                                                    <td width="200">
                                                        <div class="input-group rounded-12 overflow-hidden p-1">
                                                            <input
                                                                type="text"
                                                                step="any"
                                                                class="form-control"
                                                                placeholder="Prix "
                                                                v-model="value.price"
                                                                :id="'foodAttributesPrice' + index"
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-6 col-xs-12">
                                            <div class="form-group">
                                                <label for="attribute" class="form-label">Options </label>
                                                <v-select
                                                    class="v-select"
                                                    id="attribute"
                                                    v-model="selectedAttributes"
                                                    :options="ListAttributes"
                                                    label="name"
                                                    :clearable="true"
                                                    @close="handleSelectAttributesClose"
                                                    :placeholder="'-- Sélectionnez une option --'"
                                                >
                                                    <template v-slot:no-options="{ search, searching }">
                                                        <template v-if="searching">
                                                            Aucun résultat trouvé pour <em>{{ search }}</em
                                                            >.
                                                        </template>
                                                        <em v-else style="opacity: 0.5">Aucun élément n'est trouvé.</em>
                                                    </template>
                                                </v-select>
                                            </div>

                                            <span
                                                class="btn btn-sm btn-dark mt-3 rounded-12 fw-semibold fs-xs width-btn-option-food line_height29"
                                                @click="addAttribute"
                                            >
                                                Valider</span
                                            >
                                        </div>

                                        <div class="col-lg-6 col-xs-12">
                                            <table>
                                                <tr
                                                    class="form-group"
                                                    v-for="(value, index) in selectedAttributes?.values"
                                                    :key="index"
                                                >
                                                    <td width="250">
                                                        <label :for="'selectedAttributeCheckbox' + index" class="form-label">
                                                            <input
                                                                type="checkbox"
                                                                :value="value.id"
                                                                :checked="value.checked"
                                                                :id="'selectedAttributeCheckbox' + index"
                                                                @change="handleCheckboxChange($event, index)"
                                                            />
                                                            {{ value.key }}
                                                        </label>
                                                    </td>
                                                    <td width="200">
                                                        <div class="input-group rounded-12 overflow-hidden p-1">
                                                            <input
                                                                type="text"
                                                                step="any"
                                                                class="form-control"
                                                                placeholder="Prix "
                                                                :id="'price_' + index"
                                                                v-model="value.price"
                                                            />
                                                        </div>
                                                    </td>

                                                    <td v-if="value.deleteItem">
                                                        <span
                                                            class="btn btn-sm btn-delete mt-1"
                                                            @click="deleteAttributeValue(index)"
                                                        >
                                                            -
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr v-if="selectedAttributes?.id">
                                                    <td>
                                                        <span
                                                            class="btn btn-sm btn-dark btn-small mt-1 px-4 rounded-12 fs-xs fw-semibold pt-0 line-height38"
                                                            style="cursor: pointer; height: 40px !important"
                                                            @click="addCustomAttributeValue"
                                                        >
                                                            Ajouter</span
                                                        >

                                                        <div
                                                            v-if="showInsertNewAttribute"
                                                            class="tooltip pt-3"
                                                            @mouseleave="hideCustomerAttributeValuePopup"
                                                        >
                                                            <span
                                                                class="mb-2 p-1 float-end btn_close_foodMD"
                                                                @click="hideCustomerAttributeValuePopup"
                                                            >
                                                                <i class="fa fa-times"></i>
                                                            </span>
                                                            <input
                                                                class="form-control"
                                                                placeholder="Valeur"
                                                                v-model="newAttributeKey"
                                                            />
                                                            <input
                                                                type="text"
                                                                step="any"
                                                                class="form-control mt-2"
                                                                placeholder="Prix"
                                                                v-model="newAttributePrice"
                                                            />
                                                            <span
                                                                class="btn btn-sm btn-dark btn-small mt-1 px-4 rounded-12 mt-2 fw-semibold line-height38"
                                                                style="cursor: pointer; height: 46px !important; display: flow"
                                                                @click="addNewValueForSelectedAttributes"
                                                            >
                                                                Valider
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="imageUpload" class="form-label">Télécharger une image</label>
                                            <div class="form-control overflow-hidden text-center new-image desg_new_img">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="29"
                                                    height="24"
                                                    viewBox="0 0 29 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M7.33321 19.0016C5.66958 19.0016 4.07409 18.3694 2.89772 17.2442C1.72136 16.119 1.06049 14.5929 1.06049 13.0016C1.06049 11.4103 1.72136 9.88414 2.89772 8.75892C4.07409 7.6337 5.66958 7.00156 7.33321 7.00156C7.72613 5.25113 8.87556 3.71287 10.5287 2.72518C11.3472 2.23613 12.2647 1.89696 13.2289 1.72705C14.1931 1.55713 15.185 1.5598 16.148 1.7349C17.1111 1.90999 18.0263 2.25409 18.8416 2.74754C19.6569 3.24098 20.3562 3.87412 20.8996 4.6108C21.443 5.34748 21.8198 6.17327 22.0086 7.04102C22.1974 7.90878 22.1944 8.8015 21.9999 9.66823H23.3332C24.5709 9.66823 25.7579 10.1599 26.633 11.0351C27.5082 11.9102 27.9999 13.0972 27.9999 14.3349C27.9999 15.5726 27.5082 16.7596 26.633 17.6347C25.7579 18.5099 24.5709 19.0016 23.3332 19.0016H21.9999"
                                                        stroke="#021832"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M9.99988 15L13.9999 11L17.9999 15"
                                                        stroke="#021832"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M13.9999 11V23"
                                                        stroke="#021832"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                                <label class="form-control text-center" id="file-label" for="imageUpload"
                                                    >New Image</label
                                                >
                                                <input
                                                    type="file"
                                                    id="imageUpload"
                                                    @change="handleImageUpload"
                                                    class="form-control d-none"
                                                />
                                                <div v-if="food.image" class="mt-3">
                                                    <img :src="food.image" alt="Carte image" class="img-thumbnail" width="300" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center mt-4 pt-2 gap-40 flex-wrap mx-6">
                                    <a
                                        href="/back-office/food/category"
                                        class="btn btn-outline-dark line_height41 rounded-12 fw-semibold width-btn height_btn_page"
                                    >
                                        Annuler
                                    </a>
                                    <button type="submit" class="btn btn-dark rounded-12 fw-semibold width-btn height_btn_page">
                                        {{ Object.keys(this.data).length === 0 ? 'Ajouter' : 'Mettre à jour' }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    props: ['data', 'category', 'grouped_atttibute_menu', 'country_vat_rates'],
    data() {
        return {
            isFoodCategory: true,
            food: {
                name: '',
                active: true,
                subtitle: '',
                description: '',
                seo_description: '',
                seo_title: '',
                seo_keywords: '',
                short_description: '',
                image: '',
                price: '',
                price_ht: '',
                vat_rate: 0,
                price_takeaway: '',
                price_ht_takeaway: '',
                vat_rate_takeaway: 0,
                price_delivery: '',
                price_ht_delivery: '',
                vat_rate_delivery: 0,
                category_id: '-- Selectionne la catégorie --',
                kitchen_id: '-- Selectionne la cuisine --',
                supplements: [],
                boissons: [],
                complements: [],
                sauces: [],
                supplementFreeItem: null,
                complementFreeItem: null,
                boissonFreeItem: null,
                saucesFreeItem: null,
                attribute: "-- Selectionne l'option --",
                attributes: "-- Selectionne l'option --",
                is_active_takeaway: false,
                is_active_delivery: false,
            },
            foodCategories: [],
            supplements: [],
            complements: [],
            categories: [],
            attributes: [],
            kitchens: [],
            sauces: [],
            boissons: [],
            selectedAttributes: [],
            foodAttributes: [],

            newAttributeKey: '',
            newAttributePrice: '',
            showInsertNewAttribute: false,
            paramsSlug: '',

            optionsArray: ['sauce', 'supplements', 'complements', 'boissons'],
        }
    },

    computed: {
        ListCategories() {
            return this.categories
        },
        ListKitchens() {
            return this.kitchens
        },
        ListAttributes() {
            return this.attributes
        },
        filteredSupplements() {
            return this.supplements.filter((item) => !this.food?.supplements.some((selected) => selected.id === item.id))
        },
        filteredBoissons() {
            return this.boissons.filter((item) => !this.food?.boissons.some((selected) => selected.id === item.id))
        },
        filteredSauces() {
            return this.sauces.filter((item) => !this.food?.sauces.some((selected) => selected.id === item.id))
        },
        filteredComplements() {
            return this.complements.filter((item) => !this.food?.complements.some((selected) => selected.id === item.id))
        },
    },

    methods: {
        handleSelectAttributesClose() {
            console.log('handleSelectAttributesClose')
        },

        formatPriceWithSymbol(price, decimal = 2) {
            if (price == null || price == '') return '--.--'
            const num = parseFloat(price)
            if (isNaN(num)) return '--.--'
            return `${num.toFixed(decimal)} ${this.$symbolCurrency}`
        },

        formatPrice(price, decimal = 2) {
            if (price == null || price == '') return null
            const num = parseFloat(price)
            if (isNaN(num)) return null
            return `${num.toFixed(decimal)}`
        },

        addAttribute() {
            const existingIndex = this.foodAttributes.findIndex((item) => item.id === this.selectedAttributes?.id)

            if (existingIndex !== -1) {
                this.foodAttributes[existingIndex].values = this.selectedAttributes?.values
            } else {
                this.foodAttributes.push({
                    id: this.selectedAttributes?.id,
                    name: this.selectedAttributes?.name,
                    values: this.selectedAttributes?.values,
                })
            }

            this.selectedAttributes = []
        },

        addNewValueForSelectedAttributes() {
            this.selectedAttributes?.values.push({
                id: 0,
                key: this.newAttributeKey,
                price: this.newAttributePrice,
                deleteItem: true,
            })

            this.newAttributeKey = ''
            this.newAttributePrice = ''
            this.showInsertNewAttribute = false
        },

        deleteOption(indexToDelete) {
            if (indexToDelete >= 0 && indexToDelete < this.foodAttributes.length) {
                this.foodAttributes.splice(indexToDelete, 1)
            }
        },

        deleteAttributeValue(index) {
            if (index >= 0 && index < this.selectedAttributes.values.length) {
                this.selectedAttributes.values.splice(index, 1)
            }
        },

        calculatePrice() {
            const vatRate = parseFloat(this.food.vat_rate) || 0
            const price = parseFloat(this.food.price) || 0

            if (vatRate >= 0 && price >= 0) {
                this.food.price_ht = (price / (1 + vatRate / 100)).toFixed(this.decimalPriceHt)
            }
        },

        calculatePriceHT() {
            const vatRate = parseFloat(this.food.vat_rate) || 0
            const priceHT = parseFloat(this.food.price_ht) || 0

            if (vatRate >= 0 && priceHT >= 0) {
                this.food.price = (priceHT * (1 + vatRate / 100)).toFixed(this.decimalPrice)
            }
        },

        calculatePriceTakeaway() {
            const vatRateTakeaway = parseFloat(this.food.vat_rate_takeaway) || 0
            const priceTakeaway = parseFloat(this.food.price_takeaway) || 0

            if (vatRateTakeaway > 0 && priceTakeaway >= 0) {
                this.food.price_ht_takeaway = (priceTakeaway / (1 + vatRateTakeaway / 100)).toFixed(this.decimalPriceHt)
            }
        },

        calculatePriceHTTakeaway() {
            const vatRateTakeaway = parseFloat(this.food.vat_rate_takeaway) || 0
            const priceHTTakeaway = parseFloat(this.food.price_ht_takeaway) || 0

            if (vatRateTakeaway > 0 && priceHTTakeaway >= 0) {
                this.food.price_takeaway = (priceHTTakeaway * (1 + vatRateTakeaway / 100)).toFixed(this.decimalPrice)
            }
        },

        calculatePriceDelivery() {
            const vatRateDelivery = parseFloat(this.food.vat_rate_delivery) || 0
            const priceDelivery = parseFloat(this.food.price_delivery) || 0

            if (vatRateDelivery > 0 && priceDelivery >= 0) {
                this.food.price_ht_delivery = (priceDelivery / (1 + vatRateDelivery / 100)).toFixed(this.decimalPriceHt)
            }
        },

        calculatePriceHTDelivery() {
            const vatRateDelivery = parseFloat(this.food.vat_rate_delivery) || 0
            const priceHTDelivery = parseFloat(this.food.price_ht_delivery) || 0

            if (vatRateDelivery > 0 && priceHTDelivery >= 0) {
                this.food.price_delivery = (priceHTDelivery * (1 + vatRateDelivery / 100)).toFixed(this.decimalPrice)
            }
        },

        handleSubmit() {
            this.category = this.food.category_id
            this.food.attributes = this.foodAttributes

            if (Object.keys(this.data).length !== 0) {
                this.updateMenu()
            } else {
                this.storeMenu()
            }
        },

        async storeMenu() {
            if (this.food.category_id === '-- Selectionne la catégorie --') {
                this.food.category_id = null
            }

            if (this.food.kitchen_id === '-- Selectionne la cuisine --') {
                this.food.kitchen_id = null
            }

            await this.clearFoodData()

            axios
                .post('/back-office/food', this.food)
                .then((response) => {
                    window.location.href = '/back-office/food?slug=' + this.category?.slug
                })
                .catch((error) => {
                    console.error('Error creating food:', error)
                    this.showErrors(error)
                })
        },

        updateMenu() {
            const foodId = this.data.id
            axios
                .put(`/back-office/food/${foodId}`, this.food)
                .then((response) => {
                    console.log('updated:', response.data)
                    this.$toast.success(this.$t('food.menus.updated_success'))
                })
                .catch((error) => {
                    console.error('Error updating food:', error)
                    this.showErrors(error)
                })
        },

        clearFoodData() {
            if (this.food.supplements) {
                const supplements = this.food.supplements.map((supplement) => {
                    return {
                        id: supplement.id,
                        name: supplement.name,
                        price: supplement.price,
                        isFree: supplement.isFree,
                        isRequired: supplement.isRequired,
                        forceOneQty: supplement.forceOneQty,
                    }
                })

                this.food.supplements = supplements
            }

            if (this.food.boissons) {
                const boissons = this.food.boissons.map((boisson) => {
                    return {
                        id: boisson.id,
                        name: boisson.name,
                        price: boisson.price,
                        isFree: boisson.isFree,
                        isRequired: boisson.isRequired,
                        forceOneQty: boisson.forceOneQty,
                    }
                })

                this.food.boissons = boissons
            }

            if (this.food.complements) {
                const complements = this.food.complements.map((complement) => {
                    return {
                        id: complement.id,
                        name: complement.name,
                        price: complement.price,
                        isFree: complement.isFree,
                        isRequired: complement.isRequired,
                        forceOneQty: complement.forceOneQty,
                    }
                })

                this.food.complements = complements
            }

            if (this.food.sauces) {
                const sauces = this.food.sauces.map((sauce) => {
                    return {
                        id: sauce.id,
                        name: sauce.name,
                    }
                })

                this.food.sauces = sauces
            }
        },

        fetchCategories() {
            axios
                .get('/back-office/food/category/list/fast')
                .then((response) => {
                    this.categories = response.data?.data
                })
                .catch((error) => {
                    console.error('Error fetching categories:', error)
                })
        },

        fetchKitchens() {
            axios
                .get('/back-office/food/kitchen/list/fast')
                .then((response) => {
                    console.log('resp', response.data)
                    this.kitchens = response.data?.data
                })
                .catch((error) => {
                    console.error('Error fetching categories:', error)
                })
        },

        fetchFoods() {
            const params = new URLSearchParams({
                categories: this.optionsArray.join(','),
                relations: ['category', 'kitchen'],
                groupBy: 'category.slug',
            })

            axios
                .get('/back-office/food/list/fast?' + params)
                .then((response) => {
                    console.log('resp /*/', response.data.data)

                    let _data = response?.data?.data ?? []

                    for (let category in _data) {
                        if (category == 'supplements') {
                            this.supplements = _data[category]
                        }

                        if (category == 'complements') {
                            this.complements = _data[category]
                        }

                        if (category == 'sauce') {
                            this.sauces = _data[category]
                        }

                        if (category == 'boissons') {
                            this.boissons = _data[category]
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error fetching categories:', error)
                })
        },

        fetchAttribute() {
            axios
                .get('/back-office/food/attribute/list/fast')
                .then((response) => {
                    console.log('resp', response.data)
                    this.attributes = response.data?.data
                    // this.foodAttributes = response.data?.data

                    this.attributesOnUpdate()
                })
                .catch((error) => {
                    console.error('Error fetching attributes:', error)
                })
        },

        handleCheckboxChange(event, index) {
            const valueId = event.target.value
            const isChecked = event.target.checked
            const findValue = this.selectedAttributes.values.find((x) => x.id == valueId)
            findValue.checked = isChecked
        },

        handleItemValueCheckboxChange(event, indexItem) {
            const valueId = event.target.value
            const isChecked = event.target.checked
            const findValue = this.foodAttributes[indexItem].values.find((x) => x.id == valueId)
            findValue.checked = isChecked
        },

        handleIsActiveTakeawayChange(event) {
            if (!event.target.checked) {
                this.food.price_takeaway = ''
                this.food.price_ht_takeaway = ''
                this.food.vat_rate_takeaway = 0
            }
            this.$forceUpdate()
        },

        handleIsActiveDeliveryChange(event) {
            if (!event.target.checked) {
                this.food.price_delivery = ''
                this.food.price_ht_delivery = ''
                this.food.vat_rate_delivery = 0
            }
            this.$forceUpdate()
        },

        handleCheckboxSupplementsChange(event, el) {
            const valueId = event.target.value
            const isChecked = event.target.checked
            const valueInFoodSupplements = this.food.supplements.find((x) => x.id == valueId)
            valueInFoodSupplements.price = isChecked && el == 'isFree' ? 0 : ''
            // valueInFoodSupplements.isFree = isChecked

            valueInFoodSupplements.isFree = el == 'isFree' ? isChecked : valueInFoodSupplements?.isFree
            valueInFoodSupplements.isRequired = el == 'isRequired' ? isChecked : valueInFoodSupplements?.isRequired
            valueInFoodSupplements.forceOneQty = el == 'forceOneQty' ? isChecked : valueInFoodSupplements?.forceOneQty
        },

        handleCheckboxDrinksChange(event) {
            const valueId = event.target.value
            const isChecked = event.target.checked
            const valueInFoodSupplements = this.food.boissons.find((x) => x.id == valueId)
            valueInFoodSupplements.price = isChecked ? 0 : ''
            valueInFoodSupplements.isFree = isChecked
        },

        handleCheckboxComplementsChange(event) {
            const valueId = event.target.value
            const isChecked = event.target.checked
            const valueInFoodComplements = this.food.complements.find((x) => x.id == valueId)
            valueInFoodComplements.price = isChecked ? 0 : ''
            valueInFoodComplements.isFree = isChecked
        },

        handleCheckboxSaucesChange(event) {
            const valueId = event.target.value
            const isChecked = event.target.checked
            const valueInFoodSauces = this.food.sauces.find((x) => x.id == valueId)
            valueInFoodSauces.price = isChecked ? 0 : ''
            valueInFoodSauces.isFree = isChecked
        },

        handleSupplementFreeItemChange(val) {
            if (this.food.supplements.length < val) {
                this.$toast.error(this.$t('food.menus.included_items_exceeds_supplements'))

                this.food.supplementFreeItem = this.food.supplements.length
            }
        },

        handleBoissonFreeItemChange(val) {
            if (this.food.boissons.length < val) {
                this.$toast.error(this.$t('food.menus.included_items_exceeds_drinks'))

                this.food.boissonFreeItem = this.food.boissons.length
            }
        },

        handleComplementFreeItemChange(val) {
            if (this.food.complements.length < val) {
                this.$toast.error(this.$t('food.menus.included_items_exceeds_sides'))

                this.food.complementFreeItem = this.food.complements.length
            }
        },

        handleSaucesFreeItemChange(val) {
            if (this.food.sauces.length < val) {
                this.$toast.error(this.$t('food.menus.included_items_exceeds_sauces'))

                this.food.saucesFreeItem = this.food.sauces.length
            }
        },

        showErrors(response) {
            if (response && response.response && response.response.data && response.response.data.errors) {
                const errors = response.response.data.errors

                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        const errorMessage = errors[key][0]
                        this.showErrorNotification(errorMessage)
                    }
                }
            } else if (response && response.response && response.response.data && response.response.data.message) {
                this.showErrorNotification(response.response.data.message)
            } else {
                this.showErrorNotification('An error occurred. Please try again.')
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },

        attributesOnUpdate() {
            if (this.attributes.length === 0 || Object.keys(this.data).length === 0) return

            this.attributes.forEach((attribute) => {
                let values = []
                attribute?.values.forEach((value) => {
                    let findAttVal = this.food?.menu_attribute.find((item) => item.attribute_value_id === value.id)
                    values.push({
                        id: value.id,
                        key: value.key,
                        value: value.value,
                        attribute_id: value.attribute_id,

                        checked: findAttVal ? true : false,
                        price: findAttVal ? findAttVal.price : null,
                    })
                })

                if (values.filter((v) => v.checked).length > 0) {
                    this.foodAttributes.push({
                        id: attribute.id,
                        name: attribute.name,
                        values: values,
                    })
                }
            })
        },

        addCustomAttributeValue() {
            // this.newAttributeKey = "";
            // this.newAttributePrice = "";
            this.showInsertNewAttribute = true
        },

        hideCustomerAttributeValuePopup() {
            this.showInsertNewAttribute = false
        },

        onClickOutside() {
            // this.hideCustomerAttributeValuePopup()
        },

        handleImageUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.food.image = e.target.result
                }
                reader.readAsDataURL(file)
            }
        },

        disableIncrementDecrement(event) {
            event.target.setAttribute('min', event.target.value)
            event.target.setAttribute('max', event.target.value)
        },

        enableIncrementDecrement(event) {
            event.target.removeAttribute('min')
            event.target.removeAttribute('max')
        },
    },

    mounted() {
        // let slugs = ['entrees', 'desserts', 'boissons', ' ', '']
        // let existSlug = slugs.includes(this.category?.slug)

        // this.isFoodCategory = this.category?.slug == "food" ||  this.category?.parent?.slug == "food"  && !existSlug ? true : false;

        if (Object.keys(this.data).length !== 0) {
            this.food = { ...this.data }

            this.food.price = this.formatPrice(this.food?.price || 0, this.$priceDecimal)
            this.food.price_takeaway = this.formatPrice(this.food?.price_takeaway || 0, this.$priceDecimal)
            this.food.price_delivery = this.formatPrice(this.food?.price_delivery || 0, this.$priceDecimal)

            this.food.category_id = {
                id: this.data?.category?.id ?? null,
                name: this.data?.category?.name,
            }

            console.log('this.food.category_id', this.food.category_id)

            this.food.kitchen_id = {
                id: this.data?.kitchen?.id,
                name: this.data?.kitchen?.name,
            }

            const priceTakeaway = parseFloat(this.food.price_takeaway) || 0
            this.food.is_active_takeaway = priceTakeaway > 0

            const priceDelivery = parseFloat(this.food.price_delivery) || 0
            this.food.is_active_delivery = priceDelivery > 0
        } else if (this.category && this.category.id) {
            this.food.category_id = {
                id: this.category?.id ?? null,
                name: this.category?.name ?? null,
            }
        }

        this.fetchCategories()
        this.fetchKitchens()
        this.fetchFoods()
        this.fetchAttribute()

        document.addEventListener('click', this.onClickOutside)

        const params = new URLSearchParams(window.location.search)
        this.paramsSlug = params.get('slug')

        console.log('this.food', this.food.supplements)
    },

    beforeUnmount() {
        document.removeEventListener('click', this.onClickOutside)
    },

    components: {
        vSelect,
    },
}
</script>

<style lang="scss" scoped>
.v-select .vs__dropdown-toggle {
    color: #94a3b8;
    background-color: #fff;
    border-color: #e2e8f0;
    border-radius: 12px;
    min-height: 56px;
    cursor: pointer;
}

.tooltip {
    position: absolute;
    background-color: #fff;
    color: #0238;
    border: solid 1px #e2e8f0;
    padding: 20px;
    border-radius: 13px;
    z-index: 999;
    max-width: 500px;
    margin-top: -8rem;
    box-shadow: 0px 0px 7px 2px #e2e8f0;
}

.tooltip input,
.tooltip button {
    margin-bottom: 5px;
    display: block;
}

.float-end {
    float: inline-end;
}
.vs__selected {
    background-color: #fff;
    border: solid 1px #94a3b8;
    border-radius: 8px;
    color: var(--vs-selected-color);
    margin: 8px 4px 6px;
    padding: 6px 0.25em;
}
.vs__deselect {
    fill: #021832;
    margin-left: 12px;
    margin-right: 5px;
}
.vs__open-indicator {
    margin-right: 9px;
    fill: #94a3b8;
}
.btn-delete {
    border: solid;
    display: flex;
    width: 32px;
    height: 32px;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 32px;
    border: 1px solid var(--Grey, #94a3b8);
    background: #fff;
    color: #94a3b8;
    font-family: Poppins Regular;
    font-size: 13px;
    line-height: normal;
}
.btn_close_foodMD {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #f8fafc !important;
    margin: 0 !important;
    height: 38px;
    width: 41px;
    margin-bottom: 10px !important;
}
.vs__dropdown-menu {
    height: 147px;
    border-radius: 12px;
}
.vue-notification.error {
    background: linear-gradient(90deg, rgba(249, 233, 233, 1) 0%, rgba(249, 235, 236, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #de2c2c;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    max-height: 100px;
    width: fit-content !important;
    border-radius: 8px;
    line-height: 38px;
    max-width: fit-content !important;
    z-index: 9999;
    right: 35px !important;
}
.vue-notification-title {
    border-bottom: none;
    font-size: 16px;
    font-family: Poppins Regular;
    color: #021832 !important;
    margin-left: 10px;
}
.vue-notification.success {
    background: linear-gradient(90deg, rgba(227, 248, 235, 1) 0%, rgba(238, 249, 243, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #01e17b !important;
    border: none;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    max-height: 100px;
    width: max-content !important;
    border-radius: 8px;
    line-height: 38px;
    max-width: fit-content !important;
    z-index: 9999;
    right: 35px !important;
}
.error .vue-notification-title::before {
    content: url('/media/cancel.svg');
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    top: 45%;
    transform: translateY(-50%);
    background-size: cover;
}
.success .vue-notification-title::before {
    content: url('/media/check_circle.svg');
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    top: 45%;
    transform: translateY(-50%);
    background-size: cover;
}
.vue-notification-msg {
    font-size: 16px;
    font-weight: 400;
    font-family: Poppins Regular;
    color: #021832 !important;
    margin-left: 10px;
}

.no-increment::-webkit-inner-spin-button,
.no-increment::-webkit-outer-spin-button {
    pointer-events: none;
    opacity: 1;
}

.inline-block {
    display: inline-block;
}
</style>
